<template>
    <default needs-project>
        <div id="Fs_main">
            <button :disabled="!bucket" class="Fs_main_top1 bt bt-normal bt-hover-dark" @click="set_bucket(null)">
                <i class="fas fa-arrow-left"></i>
                select new bucket
            </button>
            <file-path v-if="bucket" class="Fs_main_top2" v-on:selectHistory="set_bucketPath($event)"></file-path>
            <bucket-list class="Fs_main_bottom" v-if="!bucket" :buckets="buckets" v-on:selectBucket="set_bucket($event)"></bucket-list>
            <files class="Fs_main_bottom" v-if="bucket" :files="files" :path="filePath" v-on:selectFolder="selectFolder($event)"></files>
        </div>
    </default>
</template>

<script>
import Default from '../components/layouts/Default'
import BucketList from "../components/fs/bucketList";
import Files from "../components/fs/files";
import FilePath from "../components/fs/filePath";
export default {
    name: 'Fs',
    components: {FilePath, Files, BucketList, Default },
    data () {
    return {

    }
    },
    computed: {
        buckets () {
            return this.$store.getters['Fs/get_buckets']
        },
        bucketPath(){
            return this.$store.getters['Fs/get_bucketPath']
        },
        bucket(){
            return this.$store.getters['Fs/get_bucket']
        },
        files(){
            return this.$store.getters['Fs/get_files']
        },
        filePath(){
            return process.env.VUE_APP_JOAT_URL + '/fs/buckets/' + this.bucket.hash + '/files?path=' + this.bucketPath + '/'
        }
    },
    methods: {
        api_index_buckets () {
            this.$store.dispatch('Fs/api_index_buckets')
        },
        api_index_files(){
            this.$store.dispatch('Fs/api_index_files')
        },
        set_bucket (bucket) {
            this.$store.commit('Fs/set_bucket', bucket);
            this.$store.commit('Fs/set_bucketPath', '');
            this.$store.commit('Fs/set_files', null);
            this.api_index_files();
        },
        set_bucketPath(path){
            this.$store.commit('Fs/set_bucketPath', path);
            this.$store.commit('Fs/set_files', []);
            this.api_index_files();
        },
        selectFolder(name){
            this.$store.commit('Fs/set_bucketPath', this.bucketPath + '/' + name);
            this.$store.commit('Fs/set_files', []);
            this.api_index_files();
        }
    },
    mounted () {
        this.api_index_buckets()
    }
}
</script>

<style scoped>
    #Fs_main{
        display: grid;
        width: 100%;
        grid-template-areas:
        "fsmaintop1 fsmaintop2 ."
        "fsmainbottom fsmainbottom fsmainbottom";
        grid-template-rows: 40px auto;
        grid-template-columns: 150px auto auto;
    }
    .Fs_main_top1{
        grid-area: fsmaintop1;
    }
    .Fs_main_top2{
        grid-area: fsmaintop2;
    }
    .Fs_main_bottom{
        grid-area: fsmainbottom;
    }
</style>
